import { useState } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

const useWelcome = () => {
  const [showErrorNotification, setShowErrorNotification] = useState(false);

  const { loginWithRedirect, error } = useAuth0();

  if (error) {
    setShowErrorNotification(true);
    throw new Error('Failed to login');
  }

  // const apiBaseURL = useSelector(configSelector.apiBaseUrl);
  // const apiVersion = useSelector(configSelector.getApiVersion);

  // const handleLogin = async () => {
  //   const tenantName = window.location.hostname.split('.')[0] || '';

  //   try {
  //     const response = await fetch(`${apiBaseURL}/iam/auth/login/${tenantName}`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'DUCKENERGY-API-VERSION': apiVersion.toString(),
  //       },
  //     });
  //     if (!response.ok) {
  //       setShowErrorNotification(true);
  //       throw new Error('Failed to fetch redirect URL');
  //     }
  //     const { loginUrl }: LoginResponse = (await response.json()) as LoginResponse;

  //     window.location.replace(loginUrl);
  //   } catch (error) {
  //     setShowErrorNotification(true);
  //     console.error('Error fetching redirect URL:', error);
  //   }
  // };

  return { showErrorNotification, loginWithRedirect };
};

export default useWelcome;
